/*jshint esversion: 6 */
/* jshint expr: true */
/*jshint -W008 */

(function ($, root, undefined) {

	$(function () {

		var CN_MAIN = {
			window_loaded: false,
	  
			bindingsRegistered: false,
	  
			eventListenersRegistered: false,
	  
			docStyle: getComputedStyle(document.documentElement),
	  
			SETTINGS: {
				'mobile': 600,
				'tabletPortrait': 900,
				'tabletLandscape': 1200
			},
	  
			init: function init() {
				console.log('main init');
				this.registerEvenListeners();
				this.initPage();
			},
	  
			registerEvenListeners: function registerEvenListeners() {
				console.log('main listeners');
				let menuBtn = document.querySelector('.site-header .hamburger');

				menuBtn.addEventListener('click', this.toggleMobileNavigation.bind(this) );
			},

			toggleMobileNavigation: function toggleMobileNavigation() {
				let mainNavCnt = document.querySelector('.navigation-cnt');
				let menuBtn = document.querySelector('.site-header .hamburger');

				if ( !menuBtn.classList.contains('is-active') ) {
					menuBtn.classList.add('is-active');
					document.body.style.overflow = 'hidden';
					
					if ( !mainNavCnt.classList.contains('active') ) {
						mainNavCnt.classList.add('active');
					}

				} else {
					menuBtn.classList.remove('is-active');
					document.body.style.overflow = '';

					if ( mainNavCnt.classList.contains('active') ) {
						mainNavCnt.classList.remove('active');
					}
					
				}
			},

	  
			initPage: function initPage() {
				var cls = document.body.classList;
				switch (true) {
					case cls.contains('home'):
						CN_HOME.init();
						break;
					case cls.contains('page-template-about'):
						CN_ABOUT.init();
						break;
					case cls.contains('archive'):
						CN_ARCHIVE.init();
						break;
					default:
						console.log('no page matching criteria');
				}
			},

			
		};

		var CN_HOME = {
			
			baseUrl: window.location.href,

			init: function init() {
				console.log('home init');
				this.registerEvenListeners();
			},
	  
			registerEvenListeners: function registerEvenListeners() {
				console.log('home listeners');
			},

		};

		var CN_ABOUT = {
			init: function init() {
				console.log('About init');
				this.registerEvenListeners();

				if ( document.querySelectorAll('.gallery-cnt .img-cnt img')) {
					this.initializePortraitLandScapeLabels( document.querySelectorAll('.gallery-cnt .img-cnt img') );
				}
			},
	  
			registerEvenListeners: function registerEvenListeners() {
				console.log('About listeners');
			},

			initializePortraitLandScapeLabels: function initializePortraitLandScapeLabels(params) {
				if (!params) {
					console.log('!params is true');
				}

				params.forEach( img => {
					if (img.width > img.height ){
						img.classList.add('landscape');
					} else if (img.width < img.height){
						img.classList.add('portrait');
					} else {
						img.classList.add('square');
					}
				});
			}
		};

		var CN_ARCHIVE = {
			init: function init() {
				console.log('Shop init');
				this.registerEvenListeners();
			},
	  
			registerEvenListeners: function registerEvenListeners() {
				console.log('Shop listeners');
			},
		};

		
		var UTILITIES = {

			toggleDrawer: function toggleDrawer() {
				let info = event.target.closest('.info'),
					textCnt = info.querySelector('.text-cnt'),
					text = info.querySelector('.text');
		
				// console.log(info);
				console.log(textCnt.clientHeight);
				// console.log(`${text.scrollHeight}px`);
		
				if(!info.classList.contains('active')) {
						info.classList.add('active');
						setTimeout(() => {
							info.classList.remove('inactive');
							info.querySelector('.read-more p').innerHTML = 'Read less';
						}, 200);
						// textCnt.style.maxHeight = `${text.scrollHeight}px`;
						startAnimation(textCnt.clientHeight, text.scrollHeight, 300, textCnt);
				} else {
						info.classList.remove('active');
						info.classList.add('inactive');
						info.querySelector('.read-more p').innerHTML = 'Read more';
						// textCnt.style.maxHeight = '';
						startAnimation(text.scrollHeight, 0, 300, textCnt);
				}
		
		
				function inOutQuad(n){
						n *= 2;
						if (n < 1) return 0.5 * n * n;
						return - 0.5 * (--n * (n - 2) - 1);
				}
		
				function startAnimation(starth, desth, duration, domEl){
						let stop = false,
							start = null,
							end = null;
		
						function startAnim(timeStamp) {
								start = timeStamp;
								end = start + duration;
								draw(timeStamp);
						}
		
						function draw(now) {
								if (stop) return;
								if (now - start >= duration) stop = true;
								let p = (now - start) / duration;
								let val = inOutQuad(p);
								let h = starth + (desth - starth) * val;
		
								domEl.style.maxHeight = `${h}px`;
								requestAnimationFrame(draw);
						}
		
						requestAnimationFrame(startAnim);
				}
			},
		};


		CN_MAIN.init();

	});


})(jQuery, this);
